<template>
  <div v-if="video" class="fixed z-40 top-0 left-0 w-full h-full bg-white bg-opacity-90" @click="playVideo()">
    <div class="absolute z-40 top-0 left-0 py-8 px-4 w-full lg:w-1/4 h-full">
      <h1
        v-if="!started"
        @click="playVideo()"
        class="text-red cursor-pointer text-2xl leading-none px-4 font-display tracking-wider"
      >
        <span class="blinker">►</span> BIM’21
      </h1>
      <div
        v-if="started && title"
        class="group w-full h-full"
        @click="openMenu()"
      >
        <div class="block lg:group-hover:hidden cursor-pointer px-4">
          <img
            class="h-36 lg:h-72 w-auto max-w-none"
            src="../assets/bim21-logo.svg"
            alt="BIM ’21"
          />
        </div>
        <div class="hidden lg:group-hover:block cursor-pointer text-red">
          <h1
            class="
              text-2xl
              tracking-wider
              font-display
              pb-8
              px-4
              border-b border-red
            "
          >
            Biennale de<br />
            l’Image en<br />
            Mouvement<br />
            2021
          </h1>
          <h1
            class="
              text-2xl
              tracking-wider
              font-display
              py-8
              px-4
              border-b border-red
            "
          >
            A Goodbye Letter<br />
            A Love Call<br />
            A Wake-Up Song<br />
          </h1>
          <h1
            class="
              text-2xl
              tracking-wider
              font-display
              py-8
              px-4
              border-b border-red
            "
          >
            12.11.21–<br />
            20.02.22
          </h1>
          <h1
            class="
              text-2xl
              font-display
              py-8
              px-4
              border-b border-red
              lg:border-0
            "
          >
            Centre<br />
            d’Art<br />
            Contemporain<br />
            Genève<br />
          </h1>
        </div>
      </div>
    </div>
    <div
      v-if="started && title"
      class="
        absolute
        z-40
        bottom-0
        text-lg
        left-0
        p-8
        tracking-wider
        uppercase
        text-red
        font-display
      "
    >
      <a href="https://5e.centre.ch" target="_blank">[5e.centre.ch]</a><br />
      <a href="https://dis.art" target="_blank">[dis.art]</a>
    </div>
    <video
      v-if="!isMobile"
      ref="video"
      class="
        cursor-pointer
        absolute
        z-30
        top-0
        left-0
        w-full
        h-full
        object-cover
        transition
        duration-1000
      "
      :class="{'opacity-100': started, 'opacity-0': !started }"
      loop
      playsinline
      @click="videoClick()"
      :src="video.url"
    ></video>
    <video
      v-else
      ref="video"
      class="
        cursor-pointer
        absolute
        z-30
        top-0
        left-0
        w-full
        h-full
        object-cover
        transition
        duration-1000
      "
      :class="{'opacity-100': started, 'opacity-0': !started }"
      loop
      playsinline
      @click="videoClick()"
      :src="mobilevideo.url"
    ></video>
  </div>
</template>

<script>
export default {
  data() {
    return {
      started: false,
      title: true,
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth < 768;
    },
    video() {
      if(this.$store.state.site.video) {
        return this.$store.state.site.video[0];
      } else {
        return false;
      }
    },
    mobilevideo() {
      if(this.$store.state.site.video) {
        return this.$store.state.site.video[1];
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.$root.$on("closeMenu", () => {
      this.started = true;
      this.title = true;
      this.$refs.video.muted = false;
    });
    this.$root.$on("openMenu", () => {
      this.playVideo();
      this.$refs.video.muted = true;
      this.title = false;
    });
  },
  methods: {
    videoClick() {
      if(this.started) {
        this.openMenu()
      } else {
        this.playVideo()
      }
    },
    playVideo() {
      this.$refs.video.play();
      this.started = true;
    },
    openMenu() {
      this.$refs.video.muted = true;
      this.title = false;
      this.$root.$emit("openMenu");
    },
  },
};
</script>
